export default __webpack_public_path__ + "static/media/LendEzy.80a6aef6.png";